import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getFiscalPeriods } from "../../../../services/setup/finance/financeSetupService";
import withGlobalData from "../../common/withGlobalData";
import { Badge } from "react-bootstrap";
class SearchFiscalPeriod extends Component {
  state = { reload: this.props.globalData.reload, fiscalPeriods: [] };

  componentDidMount() {
    this.getFiscalPeriods();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getFiscalPeriods();
      this.setState({ reload: globalData.reload });
    }
  }

  async getFiscalPeriods() {
    const response = await getFiscalPeriods();
    const { data } = response.data;
    this.setState({ fiscalPeriods: data.fiscalPeriods });
  }

  render() {
    const { fiscalPeriods } = this.state;
    const { onSelectFiscalPeriod } = this.props;
    return (
      <CustomDataTableSearch
        data={fiscalPeriods}
        onRefreshData={() => {
          this.getFiscalPeriods();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectFiscalPeriod(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectFiscalPeriod(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Fiscal Period ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Year",
            field: "year",
            body: null,
            sortable: true,
          },
          {
            header: "Month",
            field: "monthName",
            body: null,
            sortable: true,
          },
          {
            header: "Period Status",
            field: "statusName",
            body: (rowData) => {
              if (rowData.statusID === 1) {
                return <Badge variant="danger">{rowData.statusName}</Badge>;
              } else if (rowData.statusID === 2) {
                return <Badge variant="primary">{rowData.statusName}</Badge>;
              } else if (rowData.statusID === 3) {
                return <Badge variant="success">{rowData.statusName}</Badge>;
              } else {
                return <Badge variant="dark">{rowData.statusName}</Badge>;
              }
            },
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchFiscalPeriod);
